/* DON'T EDIT THIS FILE: edit original and run build again */ import { htmlLiveFieldRenderers } from "./renderer.tsx";

const renderers = [htmlLiveFieldRenderers];

export default renderers;
